/**
 * Topic structure by karora on 24/05/17.
 */

export class Topic {
  id: number;
  short_name: string;
  topic: string;
  min_duration: number;
  max_duration: number;
  active: boolean;
  author: string;
  closing_time: Date;
  publication_time: Date;
  image_url: string;
  response_count: number;
  programme_id: number;
  programme_key: string;
  programme_name: string;
  type_id: number;

  public static get typeIDTopic(): number {
    return 1;
  }
  public static get typeIDWire(): number {
    return 2;
  }

  constructor() {
    this.min_duration = 3;
    this.max_duration = 30;
    this.active = true;
    this.response_count = 0;
    this.programme_id = 1;
    this.publication_time = new Date();
    this.type_id = Topic.typeIDTopic;
  }
}
